"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _formik = require("formik");

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _formValidators = require("react-platform-components/dist/form-validators");

var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));

var _reactRedux = require("react-redux");

var _CategoryOfProductPopup = _interopRequireDefault(require("./CategoryOfProductPopup"));

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _styles = require("@material-ui/styles");

var _excluded = ["field", "form"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    categoryLabel: {
      width: "100%",
      textAlign: "left"
    }
  };
});

var CategoryOfProductField = function CategoryOfProductField(props) {
  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      anchorElId = _useState4[0],
      setAnchorElId = _useState4[1];

  var classes = useStyles();

  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
    var categoryOfProductReducer = _ref.categoryOfProductReducer;
    return {
      categories: categoryOfProductReducer.categories
    };
  }),
      categories = _useSelector.categories;

  var getLabel = function getLabel() {
    var _props$values;

    if (props !== null && props !== void 0 && (_props$values = props.values) !== null && _props$values !== void 0 && _props$values.category) {
      var category = categories.find(function (cat) {
        return cat.id === props.values.category;
      });

      if (category) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
          className: "mr-2"
        }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
          id: "Category",
          defaultMessage: "Category"
        })), ": ".concat(category.name));
      }
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.categoryLabel
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Press here to select a category",
      defaultMessage: "Press here to select a category"
    }), " "), /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null));
  };

  var closePopup = function closePopup() {
    setAnchorEl(null);
    setAnchorElId(null);
  };

  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    id: "category_filter"
  }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
    name: "category",
    validate: props.required ? (0, _formValidators.required)() : null,
    component: function component(_ref2) {
      var _theme$palette, _theme$palette$backgr;

      var field = _ref2.field,
          form = _ref2.form,
          props = _objectWithoutProperties(_ref2, _excluded);

      var meta = form.getFieldMeta(field.name);
      var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
      return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
        error: hasError,
        fullWidth: true
      }, /*#__PURE__*/_react.default.createElement(_core.Button, {
        onClick: function onClick() {
          setAnchorEl(document.getElementById('category_filter'));
          setAnchorElId('category_filter');
        },
        value: field.value,
        className: "py-2",
        style: {
          color: hasError ? '#f44336' : 'black',
          borderColor: hasError ? '#f44336' : '',
          background: ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$backgr = _theme$palette.background) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.default) || "#FFF",
          height: "56px",
          border: "1px solid grey"
        },
        variant: "contained",
        fullWidth: true,
        validate: props.required ? (0, _formValidators.required)() : null
      }, getLabel()), hasError && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, null, meta.error));
    }
  })), Boolean(anchorEl) && /*#__PURE__*/_react.default.createElement(_core.Popover, {
    id: "simple-popover",
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: closePopup,
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    style: {
      maxHeight: '30rem'
    }
  }, anchorElId === 'category_filter' && /*#__PURE__*/_react.default.createElement(_CategoryOfProductPopup.default, _extends({}, props, {
    categories: categories,
    closePopup: closePopup
  }))));
};

var _default = CategoryOfProductField;
exports.default = _default;